/**
 * Utility to export data to CSV and trigger a download in the browser.
 * @param data Array of objects to export
 * @param filename Desired filename (e.g., 'leads_export.csv')
 * @param headers Optional custom headers mapping { [key in keyof T]: string }
 */
export function exportToCSV<T extends object>(
  data: T[], 
  filename: string, 
  headers?: Partial<Record<keyof T, string>>
) {
  if (!data || data.length === 0) {
    return false;
  }

  // Determine keys to export
  const keys = Object.keys(data[0]) as Array<keyof T>;
  
  // Create header row
  const headerRow = keys.map(key => {
    const label = headers?.[key] || String(key);
    return `"${label.replace(/"/g, '""')}"`;
  }).join(',');

  // Create data rows
  const rows = data.map(item => {
    return keys.map(key => {
      const value = item[key];
      const stringValue = value === null || value === undefined ? '' : String(value);
      return `"${stringValue.replace(/"/g, '""')}"`;
    }).join(',');
  });

  // Combine header and rows
  const csvContent = [headerRow, ...rows].join('\n');
  
  // Create blob and trigger download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  }
  
  return false;
}
